var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFE3E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#FFF8F7",
    strokeWidth: 5.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8642 13.0993L25.6202 23.0686C25.7079 23.2207 25.7541 23.3931 25.7541 23.5686C25.7541 23.7442 25.7079 23.9166 25.6202 24.0686C25.5324 24.2206 25.4062 24.3469 25.2542 24.4347C25.1021 24.5224 24.9297 24.5686 24.7542 24.5686H13.2422C13.0666 24.5686 12.8942 24.5224 12.7422 24.4347C12.5902 24.3469 12.4639 24.2206 12.3762 24.0686C12.2884 23.9166 12.2422 23.7442 12.2422 23.5686C12.2422 23.3931 12.2884 23.2207 12.3762 23.0686L18.1322 13.0993C18.5168 12.4326 19.4788 12.4326 19.8642 13.0993ZM18.9982 21.0006C18.8214 21.0006 18.6518 21.0709 18.5268 21.1959C18.4017 21.3209 18.3315 21.4905 18.3315 21.6673C18.3315 21.8441 18.4017 22.0137 18.5268 22.1387C18.6518 22.2637 18.8214 22.334 18.9982 22.334C19.175 22.334 19.3445 22.2637 19.4696 22.1387C19.5946 22.0137 19.6648 21.8441 19.6648 21.6673C19.6648 21.4905 19.5946 21.3209 19.4696 21.1959C19.3445 21.0709 19.175 21.0006 18.9982 21.0006ZM18.9982 16.334C18.8349 16.334 18.6773 16.3939 18.5552 16.5024C18.4332 16.611 18.3553 16.7605 18.3362 16.9226L18.3315 17.0006V19.6673C18.3317 19.8372 18.3967 20.0007 18.5134 20.1242C18.63 20.2478 18.7895 20.3221 18.9591 20.3321C19.1287 20.342 19.2957 20.2869 19.4261 20.1778C19.5564 20.0687 19.6401 19.914 19.6602 19.7453L19.6648 19.6673V17.0006C19.6648 16.8238 19.5946 16.6543 19.4696 16.5292C19.3445 16.4042 19.175 16.334 18.9982 16.334Z",
    fill: "#EB4F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/error-alert.b9fc26c9efc8817334d650137e0f9be0.svg";
export { ForwardRef as ReactComponent };